export const TRACKING_SOURCES = {
  MERCH_CARD: 'merch-card',
  CALCULATOR: 'calculator',
  SPLASH_PAGE_CARD: 'splash-page-card',
  MARKETING_PLUS_SPLASH_PAGE_CARD: 'marketing-plus-splash-page-card',
  STARTER_SPLASH_PAGE_CARD: 'starter-splash-page-card',
  PROFESSIONAL_SPLASH_PAGE_CARD: 'professional-splash-page-card',
  ENTERPRISE_SPLASH_PAGE_CARD: 'enterprise-splash-page-card',
  STARTER_SUITE_CARD: 'starter-suite-card',
  SUITE_CARD: 'suite-card',
  FREE_CARD: 'free-card',
  SUITE_CALCULATOR: 'suite-calculator',
  CMS_CARD: 'cms-card',
  MIGRATE_YOUR_SITE: 'migrate-your-site',
  CREATE_A_BUNDLE: 'create-a-bundle',
  BUNDLE_CARD: 'bundle-card',
  PRODUCT_CARD: 'product-card',
  ADD_ON_CARD: 'add-on-card',
  BREEZE_CARD: 'breeze-card',
  PAID_VS_FREE_USERS_MODAL: 'paid-vs-free-users-modal',
  PRODUCT_PAGE_HEADER: 'product-page-header',
  APP: 'pricing-pages',
  WHY_GO_HUBSPOT_CARD: 'why-go-hubspot-card',
  INTERSTITIAL: 'interstitial',
  INTERSTITIAL_HEADER: 'interstitial-header',
  PRODUCT_PAGE_FEATURE_TABLE_HEADER: 'product-page-feature-table-header',
  SUITE_FEATURE_TABLE_HEADER: 'suite-feature-table-header',
  BUNDLE_FEATURE_TABLE_HEADER: 'bundle-feature-table-header',
  SMART_CRM_FEATURE_TABLE_HEADER: 'smart-crm-feature-table-header',
  CLEARBIT_BANNER: 'clearbit-banner',
  ONBOARDING_CARD: 'onboarding-card',
  MARKETING_PLUS_CARD: 'marketing-plus-card',
  FAQ: 'faq',
  SSM0003_VAR_B_STARTER_CARD: 'ssm0003-var-b-starter-card',
  STARTER_CUSTOMER_PLATFORM_UPSELL_MERCH_CARD: 'starter-customer-platform-upsell-merch-card',
  MARKETING_HUB_ENTERPRISE_PRICE_CHANGE_BANNER: 'marketing-hub-enterprise-price-change-banner',
  MARKETING_PLUS_PAGE_FEATURE_TABLE: 'marketing-plus-page-feature-table',
  BREEZE_INTELLIGENCE_STARTER_PLATFORM_CARD: 'breeze-intelligence-starter-platform-card',
  ADD_TOKENS_CARD: 'add-tokens-card',
  WINTER_NEW_CUSTOMER_STARTER_2024_BANNER: 'winter-new-customer-starter-2024-banner',
  SSM0010_RECOMMENDED_STARTER_FOOTER: 'ssm0010_recommended_starter_footer',
  SSM0010_RECOMMENDED_STARTER_HEADER_BANNER: 'ssm0010_recommended_starter_header_banner',
  SSM0010_RECOMMENDED_SALES_FOOTER: 'ssm0010_recommended_sales_footer',
  SSM0010_RECOMMENDED_SALES_HEADER_BANNER: 'ssm0010_recommended_sales_header_banner',
  SSM0010_RECOMMENDED_STARTER_FEATURE_TABLE: 'ssm0010_recommended_starter_feature_table',
  CONTACT_SALES_PAGE: 'contact-sales-page',
  IN_APP: 'in-app',
  PUBLIC: 'public',
  BUNDLE: 'bundle',
  CMS_MIDDLE: 'crm-middle',
  CRM_MIDDLE: 'crm-middle',
  MARKETING_PLUS_MIDDLE: 'marketingplus-middle',
  MARKETING_PLUS_FOOTER: 'marketingplus-footer',
  MARKETING_MIDDLE: 'marketing-middle',
  SALES_MIDDLE: 'sales-middle',
  SERVICE_MIDDLE: 'service-middle',
  OPERATIONS_MIDDLE: 'operations-middle',
  CMS_MIDDLE_FOOTER: 'cms-footer',
  CRM_FOOTER: 'crm-footer',
  MARKETING_FOOTER: 'marketing-footer',
  SALES_FOOTER: 'sales-footer',
  SERVICE_FOOTER: 'service-footer',
  OPERATIONS_FOOTER: 'operations-footer',
  CMS_FOOTER: 'cms-footer',
  PRODUCT_PAGE: 'product-page',
  MOBILE_PRODUCT_PAGE: 'mobile-product-page',
  CRM_SUITE_MIDDLE: 'crmsuite-middle',
  CRM_SUITE_FOOTER: 'crmsuite-footer',
  SMART_CRM_MIDDLE: 'smart-crm-middle',
  SMART_CRM_FOOTER: 'smart-crm-footer',
  SMART_CRM_CARD: 'smart-crm-card'
};
// individual exports for backwards compatibility
export const {
  MERCH_CARD,
  PRODUCT_CARD,
  CALCULATOR,
  SPLASH_PAGE_CARD,
  MARKETING_PLUS_SPLASH_PAGE_CARD,
  STARTER_SPLASH_PAGE_CARD,
  PROFESSIONAL_SPLASH_PAGE_CARD,
  ENTERPRISE_SPLASH_PAGE_CARD,
  STARTER_SUITE_CARD,
  SUITE_CARD,
  FREE_CARD,
  SUITE_CALCULATOR,
  CMS_CARD,
  MIGRATE_YOUR_SITE,
  CREATE_A_BUNDLE,
  BUNDLE_CARD,
  ADD_ON_CARD,
  BREEZE_CARD,
  PAID_VS_FREE_USERS_MODAL,
  PRODUCT_PAGE_HEADER,
  APP,
  WHY_GO_HUBSPOT_CARD,
  INTERSTITIAL,
  SUITE_FEATURE_TABLE_HEADER,
  PRODUCT_PAGE_FEATURE_TABLE_HEADER,
  CLEARBIT_BANNER,
  ONBOARDING_CARD,
  BUNDLE_FEATURE_TABLE_HEADER,
  SMART_CRM_FEATURE_TABLE_HEADER,
  MARKETING_PLUS_CARD,
  SSM0003_VAR_B_STARTER_CARD,
  STARTER_CUSTOMER_PLATFORM_UPSELL_MERCH_CARD,
  MARKETING_PLUS_PAGE_FEATURE_TABLE,
  BREEZE_INTELLIGENCE_STARTER_PLATFORM_CARD,
  ADD_TOKENS_CARD,
  WINTER_NEW_CUSTOMER_STARTER_2024_BANNER,
  SSM0010_RECOMMENDED_STARTER_FOOTER,
  SSM0010_RECOMMENDED_STARTER_HEADER_BANNER,
  SSM0010_RECOMMENDED_SALES_FOOTER,
  SSM0010_RECOMMENDED_SALES_HEADER_BANNER,
  SSM0010_RECOMMENDED_STARTER_FEATURE_TABLE,
  CONTACT_SALES_PAGE,
  SMART_CRM_CARD,
  SMART_CRM_MIDDLE,
  SMART_CRM_FOOTER
} = TRACKING_SOURCES;